export function getCookie(name: string): string | undefined {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) {
        return parts?.pop()?.split(";")?.shift();
    }
}

export function setCookie(name: string, value: number|undefined, days: number, domain: string = '') {
    var expires = "";
    var cDomain = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    if (domain) {
        cDomain = "; domain=" + domain;
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/" + cDomain;
}

export function deleteCookie(name: string, domain: string = '') {
    document.cookie = name + "=" +
        ((domain)?";domain="+domain:"") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
}

export const cookieNames = {
    USER_CULTURE: 'UC',
    WALKME_CULTURE: 'Walkme_Culture',
    WALKME_SOLUTION_ID: 'Walkme_Solution_id',
    IS_TS_USER: 'IsTI2020'
};
